<template>
  <div>
    <el-card class="card-container">
      <template #header>
        <div class="card-header">
          <span>Knee Sleeve Pre-Orders</span>
        </div>
      </template>
      <div v-if="loading" class="mt-3 ml-2 mr-2">
        <el-skeleton :rows="5" animated />
      </div>
      <div v-else-if="!preorders.length">
        <el-empty description="No preorders found for your email" />
      </div>
      <div v-else>
        <div
          v-for="preorder in paginatedPreorders"
          :key="preorder.id"
          class="order-wrapper mb-2"
        >
          <div class="payment table-responsive">
            <table class="table table-borderless order-header">
              <tbody>
                <tr>
                  <td>
                    <div class="py-2">
                      <span class="d-block muted-text">ORDER PLACED</span>
                      <span>{{ formatDate(preorder.orderDate) }}</span>
                    </div>
                  </td>
                  <td>
                    <div class="py-2">
                      <span class="d-block muted-text">TOTAL</span>
                      <span>{{ preorder.total }}</span>
                    </div>
                  </td>
                  <td>
                    <div class="py-2">
                      <span class="d-block text-muted">SHIP TO</span>
                      <span>{{ getAddress(preorder) }}</span>
                    </div>
                  </td>
                  <td>
                    <div class="py-2 text-right">
                      <span class="d-block muted-text"
                        >ORDER # {{ preorder.id }}</span
                      >
                      <span
                        class="text-button"
                        @click="viewOrderDetails(preorder.id)"
                        >View order details</span
                      >
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="product table-responsive">
            <table class="table table-borderless">
              <tbody>
                <tr>
                  <td width="10%">
                    <img
                      class="rounded"
                      src="../../assets/images/knee_sleeve.png"
                      width="90"
                    />
                  </td>
                  <td width="70%">
                    <span class="font-weight-bold text-left">Knee Sleeve</span>
                    <div class="product-qty">
                      <span class="d-block mt-1"
                        >Quantity: {{ preorder.quantity }}</span
                      >
                    </div>
                  </td>
                  <td width="20%">
                    <div class="text-right">
                      <el-tag
                        ><span
                          class="font-weight-bold"
                          >{{ preorder.status }}</span
                        ></el-tag
                      >
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="pagination-wrapper">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="preorders.length"
          ></el-pagination>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { onMounted, ref, computed } from 'vue'
import firebase from '../../../firebase'
import getKneeSleevePreorders from '../../composables/getKneeSleevePreorders'
import { useRouter } from 'vue-router'
import { xray } from '../../config/pluginInit'

export default {
  mounted () {
    xray.index()
  },
  name: 'KneeSleevePreorderStatus',
  setup () {
    const user = firebase.firebaseAuth.currentUser
    const preorders = ref([])
    const { getPreordersByEmail } = getKneeSleevePreorders()
    const loading = ref(false)
    const router = useRouter()
    const currentPage = ref(1)
    const pageSize = ref(10)

    onMounted(async () => {
      loading.value = true
      preorders.value = await getPreordersByEmail(user.email)
      loading.value = false
    })

    const formatDate = (timestamp) => {
      const date = timestamp.toDate()
      const options = { month: 'long', day: 'numeric', year: 'numeric' }
      return date.toLocaleDateString('en-US', options)
    }

    const getAddress = (preorder) => {
      const addressParts = [
        preorder.streetAddress,
        preorder.address2,
        preorder.city,
        preorder.state,
        preorder.postalCode,
        preorder.country
      ].filter(part => part)

      return addressParts.join(', ')
    }

    const viewOrderDetails = (orderId) => {
      router.push({ name: 'patient.preorderDetails', params: { id: orderId } })
    }

    const paginatedPreorders = computed(() => {
      const start = (currentPage.value - 1) * pageSize.value
      const end = start + pageSize.value
      return preorders.value.slice(start, end)
    })

    const handleCurrentChange = newPage => {
      currentPage.value = newPage
    }

    return {
      loading,
      preorders,
      formatDate,
      getAddress,
      viewOrderDetails,
      paginatedPreorders,
      pageSize,
      currentPage,
      handleCurrentChange
    }
  }
}
</script>

<style scoped>
.card-container {
  margin: 0 20px 20px 20px;
}

.card-header {
  background: transparent;
  border-bottom: none;
}

.card-header span {
  font-size: 16px;
  font-weight: 500;
  color: var(--text-color) !important;
}

.order-header {
  background-color: #f0f2f2;
}

.order-wrapper {
  border: 1px solid var(--border-color);
  border-radius: 8px;
}

.text-button {
  color: #b583bc;
  font-weight: 600;
  cursor: pointer;
}

.btn {
  font-size: 12px;
  border-radius: 8px;
  box-shadow: 0 2px 5px 0 rgba(213, 217, 217, 0.5);
  margin-left: -2px;
}

.el-tag {
  height: 30px !important;
}

.pagination-wrapper {
  display: flex;
  justify-content: right;
}

</style>
